import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormTextField } from '@/components/Form/FormTextField/FormTextField';
import { useDcrFields } from '@/features/DataChangeRequest/_constants/useDcrFields';
import { DcrFormController } from '@/features/DataChangeRequest/DcrFormController/DcrFormController';
import { FormSection } from '@/features/DataChangeRequest/DcrModal/FormSection/FormSection';

import type { NameSectionValuesIn } from '../../../_schemas/HcpSchemas/NameSection.validation';

export const HcpNameSection = () => {
	const { t } = useTranslation();
	const { hcpFields } = useDcrFields();
	const {
		control,
		formState: { dirtyFields }
	} = useFormContext<NameSectionValuesIn>();
	const section = 'name';

	return (
		<FormSection title={t('Name')} id={section}>
			<DcrFormController
				name='firstNameCda_V'
				section={section}
				control={control}
				render={({ field, fieldState }) => (
					<FormTextField
						id='firstNameCda_V'
						name={field.name}
						label={hcpFields.firstNameCda_V.label}
						isRequired
						isDirty={!!dirtyFields.firstNameCda_V}
						indicateError={fieldState.error ? true : false}
						defaultValue={(field.value ?? '') as string}
						onChange={field.onChange}
					/>
				)}
			/>

			<DcrFormController
				name='middleNameCda_V'
				section={section}
				control={control}
				render={({ field, fieldState }) => (
					<FormTextField
						id='middleNameCda_V'
						name={field.name}
						label={hcpFields.middleNameCda_V.label}
						isDirty={!!dirtyFields.middleNameCda_V}
						indicateError={fieldState.error ? true : false}
						defaultValue={(field.value ?? '') as string}
						onChange={field.onChange}
					/>
				)}
			/>

			<DcrFormController
				name='lastNameCda_V'
				section={section}
				control={control}
				render={({ field, fieldState }) => (
					<FormTextField
						id='lastNameCda_V'
						name={field.name}
						label={hcpFields.lastNameCda_V.label}
						isRequired
						isDirty={!!dirtyFields.lastNameCda_V}
						indicateError={fieldState.error ? true : false}
						defaultValue={(field.value ?? '') as string}
						onChange={field.onChange}
					/>
				)}
			/>

			{/* Note(Filip): As of 15.12.2025 - hidden, until we display them on the profile page*/}
			<DcrFormController
				name='prefixCda_V'
				section={section}
				control={control}
				render={({ field, fieldState }) => (
					<FormTextField
						id='prefixCda_V'
						name={field.name}
						label={hcpFields.prefixCda_V.label}
						isDirty={!!dirtyFields.prefixCda_V}
						indicateError={fieldState.error ? true : false}
						defaultValue={(field.value ?? '') as string}
						onChange={field.onChange}
					/>
				)}
			/>

			<DcrFormController
				name='suffixCda_V'
				section={section}
				control={control}
				render={({ field, fieldState }) => (
					<FormTextField
						id='suffixCda_V'
						name={field.name}
						label={hcpFields.suffixCda_V.label}
						isDirty={!!dirtyFields.suffixCda_V}
						indicateError={fieldState.error ? true : false}
						defaultValue={(field.value ?? '') as string}
						onChange={field.onChange}
					/>
				)}
			/>
		</FormSection>
	);
};
